import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { getNameTypeContent, IdTypeContent } from 'civil-status/constants/id-type-content';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const listData: Array<ItemVM> = [
  {
    id: '',
    value: 'Nessuno',
  },
  {
    id: IdTypeContent.Atto,
    value: getNameTypeContent(IdTypeContent.Atto),
  },
  {
    id: IdTypeContent.Annotazione,
    value: getNameTypeContent(IdTypeContent.Annotazione),
  },
  {
    id: IdTypeContent.Trascrizione,
    value: getNameTypeContent(IdTypeContent.Trascrizione),
  },
  {
    id: IdTypeContent.AnnotazioneAutomatica,
    value: getNameTypeContent(IdTypeContent.AnnotazioneAutomatica),
  },
  {
    id: IdTypeContent.Rifiuto,
    value: getNameTypeContent(IdTypeContent.Rifiuto),
  },
];

const itemAttiETrscrizioni: ItemVM = {
  id: IdTypeContent.AttiETrascrizione,
  value: getNameTypeContent(IdTypeContent.AttiETrascrizione),
};

interface ListTypeContentProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
  isWithAttiETrascrizioni?: boolean;
}

const ListTypeContentComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo contenuto',
  isWithAttiETrascrizioni,
}: ListTypeContentProps): React.ReactElement => {
  const list: Array<ItemVM> = useMemo(() => {
    const resList = listData;

    if (isWithAttiETrascrizioni) {
      resList.push(itemAttiETrscrizioni);
    }

    return resList;
  }, [isWithAttiETrascrizioni]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="state-list-label">{label}</InputLabel>
      <PmiSelect
        labelId="state-list-label"
        id="state-list"
        name="state-list"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {list?.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeContentComponent.displayName = 'List Type Content component';

const ListTypeContent = memo(ListTypeContentComponent);

export default ListTypeContent as typeof ListTypeContentComponent;
